import axios from "axios";
import { compressImageFile } from "./imageCompression";

const adminToken = () => {
    try {
        return JSON.parse(localStorage.getItem("user") || "null")?.token || "";
    } catch (_) {
        return "";
    }
};

export const uploadMediaFile = async (event, isCheckingFileFormat, uploadType) => {
    try {
        let files = event.target.files;
        const uploadedMedias = [];

        for (let index = 0; index < files.length; index++) {
            const file = files.item(index);

            if (isCheckingFileFormat && !isUploadedMediaFormatSupported(file)) {
                return "Image format is not supported. Please upload an image in .jpg, .jpeg, .png, .webp, .mp4, .webm, .mp3, .m4a, .ogg, .opus format.";
            }

            if (typeof file !== "undefined") {
                // Shrink/normalize images to a ~1024px WebP master before upload so we never
                // send multi-MB originals. Non-image files (audio/video/svg/gif) pass through
                // unchanged. See src/utills/imageCompression.js and cover-image-spec.md.
                const uploadFile = await compressImageFile(file);

                const body = new FormData();
                body.append('image', uploadFile);
                // Only the book/summary cover uploader passes uploadType="cover", which tells
                // the backend to generate the thumb/detail/master variants. All other uploads
                // (post images, audio, video) send no type field and are unaffected.
                if (uploadType) {
                    body.append('type', uploadType);
                }

                // The upload API needs a signed-in caller (release review
                // REL-08) — the admin's own token, as every other panel call sends.
                const config = { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${adminToken()}` } };
                const response = await axios.post(`${process.env.REACT_APP_API_ROOT}/api/upload/file`, body, config);

                if (response.status === 200) {
                    uploadedMedias.push(response.data);
                } else {
                    return "Media upload failed, try again";
                };
            }
        }

        return uploadedMedias;
    } catch (error) {
        console.error("Error processing files ::", error);
        return "Error processing files, please try again";
    }
};

const isUploadedMediaFormatSupported = (file) => {
    const supportedFormats = [".jpg", ".jpeg", ".png", ".webp", ".mp4", ".webm", ".mp3", ".m4a", ".ogg", ".opus"];
    return supportedFormats.some(format => file.name.endsWith(format));
};